function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEmotionHappyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01 15.998c0-7.714 6.276-13.99 13.99-13.99s13.99 6.275 13.99 13.99c0 7.713-6.276 13.989-13.99 13.989S2.01 23.71 2.01 15.996zm1.975 0c0 6.625 5.39 12.015 12.015 12.015 6.625 0 12.015-5.39 12.015-12.016 0-6.625-5.39-12.015-12.015-12.015-6.625 0-12.015 5.39-12.015 12.015z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.704 14.764a1.86 1.86 0 001.859-1.858 1.86 1.86 0 00-1.859-1.859 1.86 1.86 0 00-1.858 1.859 1.86 1.86 0 001.858 1.858zM21.296 14.764a1.86 1.86 0 001.858-1.858 1.86 1.86 0 00-1.858-1.859 1.86 1.86 0 00-1.859 1.859 1.86 1.86 0 001.858 1.858zM22.463 16.837c-.494 0-.894.4-.894.894 0 2.971-2.394 5.212-5.57 5.212-3.174 0-5.569-2.241-5.569-5.212a.894.894 0 10-1.788 0c0 3.99 3.163 7 7.358 7 4.194 0 7.357-3.01 7.357-7 0-.494-.4-.894-.894-.894z",
    fill: props.color
  }));
}

export default SvgIconEmotionHappyFilled;